// extracted by mini-css-extract-plugin
export default {"rating":"_I-z","numberOfStars":"aJ-z","count":"bJ-z","barGraphSpacing":"cJ-z","barGraph":"dJ-z"};